import script from "./bgTopic.vue?vue&type=script&lang=ts&setup=true"
export * from "./bgTopic.vue?vue&type=script&lang=ts&setup=true"

import "./bgTopic.vue?vue&type=style&index=0&id=15bf6e62&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15bf6e62"]])

export default __exports__